import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import {
  postStudentsData, checkIfStudentsTermExists, fetchStudentsDetails, updateStudentData, fetchStudentDetailsByAdmission, getStudent, sendDiscountApproval, getAdminNotifications, approveDiscountAmount, rejectDiscountAmount, sendGroupNotification, sendNotification, clearOneNotification, deleteAllNotifications, downloadPdf, fetchAcademicDetails, addPenality
} from "../../../services/studentService"

const initialState = {
  addedStudentsDetails: {
    message: '',
    status: "idle",
    error: null
  },
  checkIfTermExistsDetails: {
    status: 'idle',
    data: [],
    error: null
  },
  allStudentsDetails: {
    status: 'idle',
    data: [],
    error: null
  },
  academicDetails: {
    status: 'idle',
    data: [],
    error: null
  },
  updateStudentDetails: {
    status: 'idle',
    message: '',
    error: null
  },
  getStudentDetailsByAdmissionDetails: {
    status: 'idle',
    data: {},
    error: null
  },
  studentDetails: {
    status: "idle",
    data: {},
    error: null
  },
  sendForApprovalDetails: {
    status: 'idle',
    message: '',
    error: null
  },
  notificationDetails: {
    status: 'idle',
    notifications: [],
    error: null
  },
  approveDiscountDetails: {
    status: 'idle',
    message: '',
    error: null
  },
  rejectDiscountDetails: {
    status: 'idle',
    message: '',
    error: null
  },
  sendAnnouncementDetails:{
    status: 'idle',
    message: '',
    error: null
  },
  clearSingleNotificationDetails:{
    status: 'idle',
    message: '',
    error: null
  },
  clearAllNotificationsDetails:{
    status: 'idle',
    message: '',
    error: null
  },
  getPdfDetails:{
    status: 'idle',
    url: '',
    error: null
  },
  addPenalityAmountDetails:{
    status: 'idle',
    message: '',
    error: null
  }
}

export const addStudentsDetails = createAsyncThunk(
  "student/addStudentsDetails",
  async (data) => {
    const response = await postStudentsData(data)
    return response
  }
)

export const checkIfTermExists = createAsyncThunk(
    "student/checkIfTermExists",
    async(data) => {
        const response = await checkIfStudentsTermExists(data)
        return response
    }
)

export const getStudentsDetailsByBranch = createAsyncThunk(
  "student/getStudentsDetails",
  async(data) => {
    const response = await fetchStudentsDetails(data)
    return response
  }
)

export const getAcademicYears = createAsyncThunk(
  "student/getAcademicYears",
  async() => {
    const response = await fetchAcademicDetails()
    return response
  }
)

export const getStudentDetails = createAsyncThunk(
  "student/getDetails",
  async (data) => {
    console.log("iam comming")
    const response = await getStudent(data)
    return response
  }
) 

export const updateStudentDetails = createAsyncThunk(
  "student/updateStudentDetails",
  async(data) => {
    const response = await updateStudentData(data)
    return response
  }
)

export const getStudentDetailsByAdmission = createAsyncThunk(
  "student/getStudentDetailsByAdmission",
  async(data) => {
    const response = await fetchStudentDetailsByAdmission(data)
    return response
  }
)

export const sendForApproval = createAsyncThunk(
  "student/sendForApproval",
  async(data) => {
    const response = await sendDiscountApproval(data)
    return response
  }
)

export const getUserNotifications = createAsyncThunk(
  "student/getUserNotifications",
  async(data) => {
    const response = await getAdminNotifications(data)
    return response
  }
)

export const approveDiscount = createAsyncThunk(
  "student/approveDiscount",
  async(data) => {
    const response = await approveDiscountAmount(data)
    return response
  }
)

export const rejectDiscount = createAsyncThunk(
  "student/rejectDiscount",
  async(data) => {
    const response = await rejectDiscountAmount(data)
    return response
  }
)

export const sendAnnouncement = createAsyncThunk(
  "student/sendAnnouncement",
  async(data) => {
    const response = await sendNotification(data)
    return response
  }
)

export const clearSingleNotification = createAsyncThunk(
  "student/clearSingleNotification",
  async(data) => {
    const response = await clearOneNotification(data)
    return response
  }
)

export const clearAllNotifications = createAsyncThunk(
  "student/clearAllNotifications",
  async(data) => {
    const response = await deleteAllNotifications(data)
    return response
  }
)

export const getPdf = createAsyncThunk(
  "student/getPdf",
  async(data) => {
    const response = await downloadPdf(data)
    return response
  }
)

export const addPenalityAmount = createAsyncThunk(
  "student/addPenalityAmount",
  async(data) => {
    const response = await addPenality(data)
    return response
  }
)


export const studentSlice = createSlice({
  name: "student",
  initialState,
  reducers: {
    resetAddStudentsDetails: (state) => {
      state.addedStudentsDetails = initialState.addedStudentsDetails
    },
    updateOrderStatus: (state, action) => {
      // console.log("jjjjjjjjjjjjjjjjjjjj//////////", action.payload)
      state.getStudentDetailsByAdmissionDetails.status = action.payload
    },
    resetCheckIfTermExistsDetailsState: (state) => {
      state.checkIfTermExistsDetails = initialState.checkIfTermExistsDetails
    },
    resetAcademicDetailsState: (state) => {
      state.academicDetails = initialState.academicDetails
    },
    resetGetStudentDetailsByAdmissionDetailsState : (state) => {
      state.getStudentDetailsByAdmissionDetails = initialState.getStudentDetailsByAdmissionDetails
    },
    resetStudentSliceState: (state) => {
      state.getStudentDetailsByAdmissionDetails = {}
      state.getStudentDetailsByAdmissionDetails.status = "idle"
    },
    resetPdfDetails: (state) => {
      state.getPdfDetails.status = "idle"
      state.getPdfDetails.url = ""
      state.getPdfDetails.error = null
    },
    resetPenalityDetails: (state) => {
      state.addPenalityAmountDetails = initialState.resetPenalityDetails
    },
    resetAllState: () => initialState
  },
  extraReducers: {
    [addStudentsDetails.pending]: (state) => {
      state.addedStudentsDetails.status = "loading"
    },
    [addStudentsDetails.fulfilled]: (state, action) => {
      if(action.payload?.message && action.payload.status !== 400) {
        state.addedStudentsDetails.status = 'succeeded'
        state.addedStudentsDetails.message = action.payload.message
      }else {
        state.addedStudentsDetails.status = "failed"
        state.addedStudentsDetails.error = "Something Went Wrong"
      }
    },
    [addStudentsDetails.rejected]: (state, action) => {
      state.addedStudentsDetails.status = "failed"
      state.addedStudentsDetails.error = action.error.message
    },

    [checkIfTermExists.pending]: (state) => {
        state.checkIfTermExistsDetails.status = "loading"
    },
    [checkIfTermExists.fulfilled]: (state, action) => {
        if(action.payload.data){
            state.checkIfTermExistsDetails.status = "succeeded"
            state.checkIfTermExistsDetails.data = action.payload.data
        }else{
            state.checkIfTermExistsDetails.status = "failed"
            state.checkIfTermExistsDetails.error = "Something Went Wrong"
        }
    },
    [checkIfTermExists.rejected]: (state, action) => {
        state.checkIfTermExistsDetails.status = "failed"
        state.checkIfTermExistsDetails.error = action.error.message
    },

    [getStudentsDetailsByBranch.pending]: (state) => {
        state.allStudentsDetails.status = "loading"
    },
    [getStudentsDetailsByBranch.fulfilled]: (state, action) => {
      if(action.payload && action.payload.status !== 400){
        state.allStudentsDetails.status = "succeeded"
        state.allStudentsDetails.data = action.payload
      }else{
        state.allStudentsDetails.status = "failed"
        state.allStudentsDetails.error = "Some Technical Issue In Getting Students"
      }
    },
    [getStudentsDetailsByBranch.rejected]: (state, action) => {
        state.allStudentsDetails.status = "failed"
        state.allStudentsDetails.error = action.error.message
    },

    [getAcademicYears.pending]: (state) => {
        state.academicDetails.status = "loading"
    },
    [getAcademicYears.fulfilled]: (state, action) => {
        if(action.payload && action.payload.status !== 400){
          state.academicDetails.status = "succeeded"
          state.academicDetails.data = action.payload
        }else{
          state.academicDetails.status = "failed"
          state.academicDetails.error = "Some Technical Issue In Getting Academic Years"
        }
    },
    [getAcademicYears.rejected]: (state, action) => {
       state.academicDetails.status = "failed"
       state.academicDetails.error = action.error.message
    },

    [getStudentDetails.pending]: (state) => {
      state.studentDetails.status = "loading"
    },
    [getStudentDetails.fulfilled]: (state, action) => {
      if (action.payload.message) {
        state.studentDetails.status = "failed"
        state.studentDetails.error = action.payload.message
      } else {
        state.studentDetails.status = "succeeded"
        console.log("iam getting data", action.payload.result)
        state.studentDetails.data = action.payload.result
      }
    },
    [getStudentDetails.rejected]: (state, action) => {
      state.studentDetails.status = "failed"
      state.studentDetails.error = action.error.message
    },

    [updateStudentDetails.pending]: (state) => {
        state.updateStudentDetails.status = "loading"
    },
    [updateStudentDetails.fulfilled]: (state, action) => {
        if(action.payload?.message && action.payload.status !== 400) {
          state.updateStudentDetails.status = 'succeeded'
          state.updateStudentDetails.message = action.payload.message
        } else {
          state.updateStudentDetails.status = 'failed'
          state.updateStudentDetails.error = "Some Technical Issue In Updating Students"
        }
    },
    [updateStudentDetails.rejected]: (state, action) => {
        state.updateStudentDetails.status = "failed"
        state.updateStudentDetails.error = action.error.message
    },

    [getStudentDetailsByAdmission.pending]: (state) => {
        state.getStudentDetailsByAdmissionDetails.status = "loading"
    },
    [getStudentDetailsByAdmission.fulfilled]: (state, action) => {
      if(action.payload && action.payload.status !== 400){
        state.getStudentDetailsByAdmissionDetails.status = "succeeded"
        state.getStudentDetailsByAdmissionDetails.data = action.payload
      }else{
        state.getStudentDetailsByAdmissionDetails.status = "failed"
        state.getStudentDetailsByAdmissionDetails.error = "No records found"
      } 
    },
    [getStudentDetailsByAdmission.rejected]: (state, action) => {
        state.getStudentDetailsByAdmissionDetails.status = "failed"
        state.getStudentDetailsByAdmissionDetails.error = action.error.message
    },

    [sendForApproval.pending]: (state) => {
        state.sendForApprovalDetails.status = "loading"
    },
    [sendForApproval.fulfilled]: (state, action) => {
        if(action.payload?.message) {
          state.sendForApprovalDetails.status = 'succeeded'
          state.sendForApprovalDetails.message = action.payload.message
        } else {
          state.sendForApprovalDetails.status = 'failed'
          state.sendForApprovalDetails.message = "Some Technical Issue"
        }
    },
    [sendForApproval.rejected]: (state, action) => {
        state.sendForApprovalDetails.status = "failed"
        state.sendForApprovalDetails.error = action.error.message
    },
   
    [getUserNotifications.pending]: (state) => {
        state.notificationDetails.status = "loading"
    },
    [getUserNotifications.fulfilled]: (state, action) => {
      if(action.payload){
        state.notificationDetails.status = "succeeded"
        state.notificationDetails.notifications = action.payload.notifications
      }else{
        state.notificationDetails.status = "failed"
        state.notificationDetails.error = "No records found"
      }
    },
    [getUserNotifications.rejected]:(state, action) => {
      state.notificationDetails.status = "failed"
      state.notificationDetails.error = action.error.message
    },

    [approveDiscount.pending]: (state) => {
      state.approveDiscountDetails.status = "loading"
    },
    [approveDiscount.fulfilled]: (state, action) => {
      if(action.payload?.message) {
        state.approveDiscountDetails.status = 'succeeded'
        state.approveDiscountDetails.message = action.payload.message
      } else {
        state.approveDiscountDetails.status = 'failed'
        state.approveDiscountDetails.message = "Some Technical Issue"
      }
    },
    [approveDiscount.rejected]: (state, action) => {
      state.approveDiscountDetails.status = "failed"
      state.approveDiscountDetails.error = action.error.message
    },

    [rejectDiscount.pending]: (state) => {
      state.rejectDiscountDetails.status = "loading"
    },
    [rejectDiscount.fulfilled]: (state, action) => {
      if(action.payload?.message) {
        state.rejectDiscountDetails.status = 'succeeded'
        state.rejectDiscountDetails.message = action.payload.message
      } else {
        state.rejectDiscountDetails.status = 'failed'
        state.rejectDiscountDetails.message = "Some Technical Issue"
      }
    },
    [rejectDiscount.rejected]: (state, action) => {
      state.rejectDiscountDetails.status = "failed"
      state.rejectDiscountDetails.error = action.error.message
    },

    [sendAnnouncement.pending]: (state) => {
      state.sendAnnouncementDetails.status = "loading"
    },
    [sendAnnouncement.fulfilled]: (state, action) => {
      if(action.payload?.message) {
        state.sendAnnouncementDetails.status = 'succeeded'
        state.sendAnnouncementDetails.message = action.payload.message
      } else {
        state.sendAnnouncementDetails.status = 'failed'
        state.sendAnnouncementDetails.message = "Some Technical Issue"
      }
    },
    [sendAnnouncement.rejected]: (state,action) => {
      state.sendAnnouncementDetails.status = "failed"
      state.sendAnnouncementDetails.error = action.error.message
    },

    [clearSingleNotification.pending]: (state) => {
      state.clearSingleNotificationDetails.status = "loading"
    },
    [clearSingleNotification.fulfilled]: (state, action) => {
      if(action.payload?.message) {
        state.clearSingleNotificationDetails.status = 'succeeded'
        state.clearSingleNotificationDetails.message = action.payload.message
      } else {
        state.clearSingleNotificationDetails.status = 'failed'
        state.clearSingleNotificationDetails.message = "Some Technical Issue"
      }
    },
    [clearSingleNotification.rejected]: (state, action) => {
      state.clearSingleNotificationDetails.status = 'failed'
      state.clearSingleNotificationDetails.error = action.error.message
    },

    [clearAllNotifications.pending]: (state) => {
      state.clearAllNotificationsDetails.status = "loading"
    },
    [clearAllNotifications.fulfilled]: (state, action) => {
      if(action.payload?.message) {
        state.clearAllNotificationsDetails.status = 'succeeded'
        state.clearAllNotificationsDetails.message = action.payload.message
      } else {
        state.clearAllNotificationsDetails.status = 'failed'
        state.clearAllNotificationsDetails.message = "Some Technical Issue"
      }
    },
    [clearAllNotifications.rejected]: (state, action) => {
      state.clearAllNotificationsDetails.status = 'failed'
      state.clearAllNotificationsDetails.error = action.error.message
    },

    [getPdf.pending]: (state) => {
      state.getPdfDetails.status = "loading"
    },
    [getPdf.fulfilled]: (state, action) => {
      if(action.payload.url){
        state.getPdfDetails.status = "succeeded"
        state.getPdfDetails.url = action.payload.url
      }else{
        state.getPdfDetails.status = "failed"
        state.getPdfDetails.url = '' 
      }
    },
    [getPdf.rejected]: (state, action) => {
        state.getPdfDetails.status = "failed"
        state.getPdfDetails.error = action.error.message
    },

    [addPenalityAmount.pending]: (state) => {
      state.addPenalityAmountDetails.status = "loading"
    },
    [addPenalityAmount.fulfilled]: (state, action) => {
      if(action.payload?.message){
        state.addPenalityAmountDetails.status = "succeeded"
        state.addPenalityAmountDetails.message = action.payload?.message
      }else{
        state.addPenalityAmountDetails.status = "failed"
        state.addPenalityAmountDetails.error = "Some Technical Issue"
      }
    },
    [addPenalityAmount.rejected]: (state, action) => {
        state.addPenalityAmountDetails.status = "failed"
        state.addPenalityAmountDetails.error = action.error.message
    }

  },
})

export const {resetPenalityDetails, resetGetStudentDetailsByAdmissionDetailsState, resetAcademicDetailsState, resetAddStudentsDetails, updateOrderStatus, resetCheckIfTermExistsDetailsState, resetStudentSliceState, resetAllState, resetPdfDetails } = studentSlice.actions

export default studentSlice.reducer
